import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
export default {
  methods: {
    uploadAll: function uploadAll() {
      var _this = this;
      if (this.$parent.$data.uploading || this.$parent.$data.files.length == 0 || this.$parent.$data.files.every(function (thing) {
        return thing === null;
      })) return;
      this.$parent.$data.uploading = true;
      this.$parent.$data.files.forEach(function (cur, index) {
        if (cur == null) return;
        _this.$parent.$data.request.append("file", cur);
        _this.$parent.$data.temporaryFiles[index].status = "uploading";
        _this.$parent.createCancelToken();
        _this.$parent.$data.temporaryFiles[index].source = _this.$parent.$data.cancellationToken.token;
        var config = {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          cancelToken: _this.$parent.$data.cancellationToken.token,
          onUploadProgress: function onUploadProgress(progressEvent) {
            var progress = progressEvent.loaded / progressEvent.total * 100;
            _this.$parent.$data.temporaryFiles[index].percent = progress;
            if (progress === 100) {}
          }
        };
        axios.post(_this.$parent.$props.url, _this.$parent.$data.request, config).then(function (response) {
          // handle success
          _this.$parent.$data.temporaryFiles[index].status = "uploaded";
          _this.$parent.$data.files[index] = null;
          if (_this.$parent.$data.files.length - 1 == index) _this.$parent.$data.uploading = false;
          if (!_this.$parent.isAllUploading()) _this.$parent.$data.uploading = false;
        }).catch(function (error) {});
        _this.$parent.$data.request.delete("file");
      });
    },
    deleteAll: function deleteAll() {
      if (this.$parent.$data.uploading) this.cancelUploadAll();
      this.$parent.$data.temporaryFiles.forEach(function (cur) {
        URL.revokeObjectURL(cur);
      });
      this.$parent.$data.temporaryFiles = [];
      this.$parent.$data.files = [];
      this.$parent.$data.request.delete("file");
      this.$emit("delete");
    },
    cancelUploadAll: function cancelUploadAll() {
      this.$parent.$data.uploading = false;
      this.$parent.$data.temporaryFiles.forEach(function (cur) {
        cur.source.cancel();
        cur.status = "cancel";
      });
    }
  }
};